<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="light-surface">
    <v-list-item two-line>
      <v-list-item-content>
        <div class="business-process">
          {{ $t('businessProcess') }}
        </div>
        <v-list-item-title class="agent-name">{{ agentName }}</v-list-item-title>
      </v-list-item-content>
      <EcsAvatar :name="agentName" :size="48" />
    </v-list-item>
    <v-row no-gutters class="py-2">
      <v-col>
        <v-chip dark small v-for="(demand, index) in demands" class="ml-4 chip-color" :key="index">
          {{ demand }}
        </v-chip>
      </v-col>
      <v-col class="text-right">
        <EcsCustomerChatActions />
      </v-col>
    </v-row>
    <div class="flex-grow-0 my-auto"></div>
  </div>
</template>

<script>
import EcsAvatar from '@/components/ecs-avatar/EcsAvatar';
import EcsCustomerChatActions from '../ecs-customer-chat-actions/EcsCustomerChatActions';

export default {
  name: 'EcsCustomerChatHeader',
  data() {
    return {
      demands: ['Demand 1', 'Demand 2'],
      agentName: 'Jane Doe'
    };
  },
  components: {
    EcsAvatar,
    EcsCustomerChatActions
  }
};
</script>

<style scoped>
.agent-name {
  font-size: 24px;
}
.business-process {
  font-size: 0.75em;
  letter-spacing: 0.16em;
  line-height: 2em;
  text-transform: uppercase;
}
.demands-row {
  justify-content: space-between;
  flex-wrap: nowrap;
}
.customer-actions {
  justify-content: center;
  display: flex;
  flex-flow: column;
}
.chip-color {
  background-color: var(--v-custom-secondary-base) !important;
}
</style>
